import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {AuthService} from "../../features/components/auth/auth.service";
import { CacheService } from 'src/app/shared/services/cache.service';


@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(private readonly authenticationService: AuthService,
    private readonly cacheService: CacheService,
    private readonly router: Router,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err.status === 401 && err.url && !err.url.includes('api/account')) {
            this.authenticationService.onLogout();
          }
        },
      }),
    );
  }
}
